export function getAppVariables() {
    const commonVars = {
        'designer-field-panel-recipients-height': '88px',
        'designer-left-panel-width': '316px',
        'designer-right-panel-width': '300px',
        'designer-navigation-width': '65px',
        'designer-mobile-header-height': '46px',
        'designer-mobile-navigation-height': '50px',
        'designer-mobile-fields-height': '120px',
        'documents-carousel-container-height': '160px',
        'document-name-container-height': '24px',
        'signers-bar-height': '88px',
        'sent-to-sign-desktop-height': '48px'
    };
    const light = {
        ...commonVars,
        'designer-right-panel-background-color': 'var(--surface-accented)',
        'designer-title-background-color': 'var(--surface-accented)',
        'designer-recipient-avatar-color': 'var(--brand-color)',
        'designer-recipient-avatar-background-color': 'rgba(23, 34, 77, 0.5)',
        'designer-left-panel-background-color': 'transparent'
    };
    const dark = {
        ...commonVars,
        'designer-right-panel-background-color': 'var(--surface-accented)',
        'designer-title-background-color': 'var(--surface-accented)',
        'designer-recipient-avatar-color': 'var(--brand-color)',
        'designer-recipient-avatar-background-color': 'rgba(23, 34, 77, 0.5)',
        'designer-left-panel-background-color': 'transparent',
        'button-primary-background-color': '#4F99F8',
        'button-primary-background-color-hover': '#2D7DDB',
        'button-primary-border-color': '#4F99F8',
        'button-primary-border-color-hover': '#2D7DDB',
        'brand-color-accented-dark': '#2D7DDB'
    };
    const lightContrast = {
        ...light,
        ...commonVars
    };

    return {
        light,
        dark,
        lightContrast
    };
}
